<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <draggable-dialog class="draggableDialog" id="attrDialog" :show.sync="attrDialog.show" :closable="false"
                    width="100%"
                    top="0px"
  >
    <template #header>
      <slot name="header">
        <div v-if="multiEditingCount === 1">
          <span class="headerLabel">属性-</span>
          <el-select style="width:110px;height: 28px;margin-left: 3px" v-model="showValue" size="mini" filterable
                     @change="changeSelect">
            <el-option
                v-for="item in showNameList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-button v-if="attrDialog.componentId !== undefined" class="deleteBtn" @click=handleDeleteBtnClick>
            删除
          </el-button>
        </div>
        <div v-else><span class="headerLabel">属性-画板背景</span></div>
      </slot>
    </template>
    <!--componentId为undefined就展示空-->
    <template #content>
      <div :style="{'height': '420px'}">
        <div v-if="multiEditingCount === 1">
          <slot name="content"></slot>
        </div>
        <div v-else>
          <slot name="content">
            <!--            <el-empty mode="list" margin-top="50"></el-empty>-->
            <div class="specificForm">
              <el-form id="CrossTwoAngleForm" :label-style="formLabelStyle">
                <el-form-item label="背景颜色">
                  <el-color-picker v-model="newBackgroundColorValue" @change="handleChange" :predefine="predefineColors"></el-color-picker>
                  <!--展示当前颜色-->
                  <span style="margin-left: 10px;">{{ newBackgroundColorValue }}</span>
                </el-form-item>
              </el-form>
            </div>
          </slot>
        </div>
      </div>
		</template>
	</draggable-dialog>
</template>

<script>
import DraggableDialog from "@/components/ProductComponents/CreateComponents/DraggableDialog";

export default {
  name: 'AttrDialog',
  components: {
    DraggableDialog
  },
  props: {
    attrDialog: Object,
    multiEditingCount: Number,
    compsJson: Object,
    backgroundColorValue:String
  },
  updated() {
    this.showValue = this.attrDialog.componentId
    // this.newBackgroundColorValue = this.backgroundColorValue;
  },
  computed: {
    showNameList() {
      let arr = [];
      for (let key in this.compsJson) {
        arr.push({
          value: key,
          label: key
        });
      }
      return arr;
    },
    //背景颜色
    newBackgroundColorValue(){
      return  this.backgroundColorValue
    }
  },
  data() {
    return {
      editingId: false,
      tempId: undefined,
      showValue: this.attrDialog.componentId,
      formLabelStyle: {
        "font-weight": 'bolder',
      },
      predefineColors: [
        '#000000',
        '#ffffff',
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
      ]
    }
  },
  mounted(){
  },
  methods: {
    //背景颜色发生变化
    handleChange(value){
      console.log("wokankanakn",value)
      console.log("wokankanakn",this.newBackgroundColorValue)
      this.$emit("changeBackgroundColor",value)
    },
    //属性框选中时发生的变化
    changeSelect(value) {
      this.$emit("changeShowAttr", value)
      console.log("我选中了什么", value)
    },
    handleDeleteBtnClick() {
      //console.log("点击了删除",this.attrDialog.componentId)
      this.$emit("deleteClick", this.attrDialog.componentId)
      // eslint-disable-next-line vue/no-mutating-props
      this.attrDialog.show = true;
      // eslint-disable-next-line vue/no-mutating-props
      this.attrDialog.componentId = undefined
    },
  }
}
</script>

<style lang="less" scoped>
#attrDialog {
  .headerLabel {
    height: 28px;
    line-height: 28px;
    max-width: 18em;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    float: left;
  }

  .headerId {
    margin-left: 10px;
    float: left;

    span {
      float: left;
    }
  }

  .editIdBtn {
    display: inline-block;
    margin-left: 2px;
    cursor: pointer;
    float: left;
  }

  .confirmBtn {
    display: inline-block;
    margin-left: 10px;
    cursor: pointer;
    float: left;
  }

  .cancelBtn {
    display: inline-block;
    margin-left: 10px;
    cursor: pointer;
    float: left;
  }

  .editIdInput {
    display: inline-block;
    float: left;

    /deep/ .u-input__input {
      height: 20px !important;
      line-height: 20px !important;
      min-height: 10px !important;
    }

    margin-left: 5px !important;
  }

  .deleteBtn {
    margin-top: -5px; //按钮解决遮盖上面文字的问题
    //left: 5px;
    float: right; // 右侧浮动
    background-color: rgb(250, 53, 52);
    color: white;
    height: 35px; //把按钮弄小解决遮盖上面文字问题
  }

  /deep/ .forms {
    max-height: 397px;
    min-height: 397px;
    // width:80%;
    overflow-y: auto;
  }

  /deep/ .forms2 {
    max-height: 500px;
    width: 95%;
    overflow-y: auto;
  }

  /deep/ .eventsCollapseItem {
    .addEventBtn {
      border: none;
      margin-bottom: 20px;
    }

    .eventItem {
      height: 90px;
      line-height: 50px;
      // display: flex;
      // justify-content: space-between;
      align-items: center;

      .div {
        display: flex;
        align-items: center;
        height: 30px;
      }

      .deleteEventBtn {
        padding: 10px;
        margin-left: 5px;
        height: 15px;
        background-color: rgb(250, 96, 96);
        color: white;
      }
    }
  }

  /deep/ .variablesEventForms {
    .addVariablesEventBtn {
      background-color: transparent;
      border: none;
      color: black;
      margin-bottom: 20px;
    }

    .variablesEventItem {
      height: 60px;
      line-height: 50px;
      // display: flex;
      // justify-content: space-between;
      align-items: center;

      .div1 {
        display: flex;
        align-items: center;
        height: 30px;
      }

      .deleteVariablesEventBtn {
        padding: 10px;
        margin: 0;
        height: 15px;
        background-color: rgb(250, 96, 96);
        color: white;
      }
    }
  }

  /deep/ .bottomBtns {
    display: flex;
    justify-content: space-between;
    margin-top: 5px; //按钮解决遮盖上面文字的问题
    .btn {
      margin: 0;
      width: 30%;

      .btnIcon {
        margin-right: 10px;
      }
    }

    .deleteBtn {
      background-color: rgb(250, 53, 52);
      color: white;
      height: 35px; //把按钮弄小解决遮盖上面文字问题
    }
  }
}
</style>
